import { Flex, Text, type FlexProps } from '@mantine/core';

type PointProps = {
  title: string;
  value: string;
  containerProps?: FlexProps;
};

export const Point = ({ title, value, containerProps }: PointProps) => {
  return (
    <Flex direction='column' gap={8} {...containerProps}>
      <Text c='tertiary.7' size='sm'>
        {title}
      </Text>
      <Text c='primary.7'>{value}</Text>
    </Flex>
  );
};
